import axios from 'axios';
import { LocalStorageService } from './local-storage.service';
import { STORAGE, API_ENDPOINT } from '../constants';
import { HttpCancelService } from './http-cancel.service';

const api = axios.create({
  baseURL: API_ENDPOINT.CORE,
  timeout: 0
});

api.interceptors.request.use(
  (config) => {
    if (!config.signal) {
      const controller = new AbortController();
      (config as any).__abortController = controller;
      config.signal = controller.signal;
      HttpCancelService.add(controller);
    }

    const token = LocalStorageService.get(STORAGE.TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    const controller = (response.config as any).__abortController as AbortController | undefined;
    if (controller) {
      HttpCancelService.remove(controller);
    }

    return response;
  },
  (error) => {
    const controller = error.config?.__abortController as AbortController | undefined;
    if (controller) {
      HttpCancelService.remove(controller);
    }

    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default api;
